type EventHandler = (...args: any[]) => void;

class EventBus {
  private events: { [key: string]: EventHandler[] } = {};

  on(event: string, callback: EventHandler) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  off(event: string, callback: EventHandler) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter(cb => cb !== callback);
  }

  emit(event: string, ...args: any[]) {
    if (!this.events[event]) return;
    this.events[event].forEach(callback => callback(...args));
  }
}

const eventBus = new EventBus();

export default eventBus;